module.exports = __webpack_public_path__ + "media/images/recruitment/bid-day-square-4ef4528b0e3deb84fed868daddcf5b2d.jpg";